import {FC} from 'react'
import { number_format } from '../helpers'

type Props = {
  num_val?: number
  num_decs?: number    
}

const NumberCell: FC<Props> = ({num_val, num_decs = 0}) => {
    

  if (typeof num_val !== 'number') {
    return null;
  }
  return (
    <div className={'align-items-center'}>
      {num_val === 0 ? '-' : number_format(num_val, num_decs)}
    </div>    
  )    

}

export {NumberCell}
